import { guided } from '../../app/guidance/fieldHelpRegistryCore';
import { curveImportFieldHelp } from '../../app/guidance/fieldHelpRegistry';

interface AIPageSelectionProps {
  chartPage: number;
  pageCount: number;
  supportingPages: number[];
  maxPages: number;
  disabled: boolean;
  onChange: (pages: number[]) => void;
}

export function AIPageSelection({
  chartPage, pageCount, supportingPages, maxPages, disabled, onChange,
}: AIPageSelectionProps) {
  const pages = [chartPage, ...supportingPages.filter((page) => page !== chartPage)]
    .sort((left, right) => left - right);
  return (
    <div className="curve-ai-page-selection">
      {pageCount > 1 ? (
        <details>
          <summary>Additional pages</summary>
          <p>Include another page only if it helps explain this graph.</p>
          <fieldset disabled={disabled}>
            <legend>Pages to include</legend>
            {Array.from({ length: pageCount }, (_, index) => index + 1)
              .filter((page) => page !== chartPage)
              .map((page) => (
                <label className="curve-inline-check" key={page}>
                  <input
                    {...guided(curveImportFieldHelp.aiFocusPage, page)}
                    type="checkbox"
                    checked={supportingPages.includes(page)}
                    disabled={!supportingPages.includes(page) && pages.length >= maxPages}
                    onChange={(event) => onChange(event.target.checked
                      ? [...supportingPages, page]
                      : supportingPages.filter((candidate) => candidate !== page))}
                  />
                  Page {page}
                </label>
              ))}
          </fieldset>
          <small>Graph page {chartPage} is included. Up to {maxPages} pages.</small>
        </details>
      ) : null}
    </div>
  );
}
